module.exports = __webpack_public_path__ + "img/newcastle-united.ca02f10f.png";